import styled from 'styled-components'

import { Card as CardComponent } from 'src/components/Ant'

const StyledCard = styled(CardComponent)`
  margin-bottom: 16px;
`

export { StyledCard }
